import { render, staticRenderFns } from "./Stock-Management.vue?vue&type=template&id=7fb4a20f&scoped=true"
import script from "./Stock-Management.vue?vue&type=script&lang=js"
export * from "./Stock-Management.vue?vue&type=script&lang=js"
import style0 from "./Stock-Management.vue?vue&type=style&index=0&id=7fb4a20f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4a20f",
  null
  
)

export default component.exports